export enum ProductEditingContext {
  ONBOARDING = 'onboarding',
  DASHBOARD = 'dashboard',
}
